import ArchiveBrowser from '../../components/ArchiveBrowser.jsx';

export default function Archive() {
  return (
    <div className="max-w-page mx-auto px-4 sm:px-6 py-6">
      <ArchiveBrowser
        headerSlot={
          <div>
            <h1 className="hxd-page-title">Archive</h1>
            <p className="text-[12px] text-hxd-muted mt-1 m-0">
              Every HXD Morning Brief, fully searchable.
            </p>
          </div>
        }
      />
    </div>
  );
}
